export default "__VITE_ASSET__CIIgByle__"